import { Component } from '@angular/core';

@Component({
  selector: 'sponsors',
  templateUrl: './sponsors.component.html'
})

export class SponsorsComponent {
  title = 'Sponsors';
}



// WEBPACK FOOTER //
// ./src/app/sponsors.component.ts